import { Point, Range } from "slate";

export const generateRange = (key: string): { point: Point, range: Range } => {
  const point = new Point({ key, offset: 0, path: [0, 0] });
  const range = new Range({
    anchor: point,
    focus: point,
  });
  return { point, range };
};
